import { Reducer } from 'redux';
import { ActionType, getType } from 'typesafe-actions';
import { PetsHelper } from '../../Utility/Helpers/Pets/PetsHelper';
import { IRewardData } from '../../Utility/RewardHelper';
import {
    TActionType,
    TransactionType,
} from '../../Utility/Tracking/DataSet/Transaction';
import {
    resetReward,
    trackReward,
} from '../../Utility/Tracking/TrackingHelpers/Resource';
import { trackResourceEvent } from '../../Utility/Tracking/TrackingHelpers/Transaction';
import { IGameState } from '../Game/IGameState';
import { MyPetMiniGameActions } from '../MyPetMiniGame/MyPetMiniGameActions';
import { PetsStateHelper } from '../Player/Pets/PetsStateHelper';
import { PlayerStateHelper } from '../Player/PlayerStateHelper';
import { PlayerTask } from '../Player/PlayerTasks';
import { InventoryStateHelper } from '../Player/Inventory/InventoryStateHelper';

export const MyPetMiniGameReducer: Reducer<IGameState> = (
    state: IGameState,
    action: ActionType<typeof MyPetMiniGameActions>
): IGameState => {
    switch (action.type) {
        case getType(MyPetMiniGameActions.claimRewards):
            return claimRewards(state, action.payload) ?? state;
    }
    return state;

    // Claim rewards
    function claimRewards(
        oldState: IGameState,
        rewards: IRewardData[]
    ): IGameState | undefined {
        let state = oldState;
        state = {
            ...state,
            playerState: InventoryStateHelper.receiveRewards(state.playerState, rewards, {
                dontTrack: true,
                queueTask: true,
            }),
        };

        for (const reward of rewards) {
            trackReward(reward);
        }
        trackResourceEvent(state, {
            transactionType: TransactionType.PET,
            tActionType: TActionType.PET_REWARD_CLAIM,
        });
        for (const reward of rewards) {
            resetReward(reward.type);
        }

        const {
            nextPetLevel,
            currentWorldMaxLevel,
        } = PetsHelper.getNextPetLevel(state);
        const startLevel = oldState.playerState.petLevel;

        state = PlayerStateHelper.setPlayerState(state, PetsStateHelper.setPetLevel(state.playerState, nextPetLevel));
        state = {
            ...state,
            playerState: PlayerStateHelper.addStateTaskDatas(
                state.playerState,
                [
                    {
                        task: PlayerTask.PET_WALK,
                        currentWorldMaxLevel: currentWorldMaxLevel,
                        endLevel: nextPetLevel,
                        petId: state.playerState.petsState.activePet,
                        startLevel,
                    },
                ]
            ),
        };

        state = {
            ...state,
            worldState: {
                ...state.worldState,
                petSpawnLevel: startLevel
            }
        }

        return state;
    }
};
